import 'react-native-get-random-values';
import { nanoid, customAlphabet } from 'nanoid';

export const generateGuid = (rule?: {
  alphabet: string;
  size: number;
}): string => {
  if (rule) {
    const customNanoId = customAlphabet(rule.alphabet, rule.size);
    return customNanoId();
  }

  return nanoid();
};

export const getAnonKey = (): string => {
  const randomNumberStr = parseInt(String(Math.random() * 10000000000), 10)
    .toString()
    .substring(0, 10)
    .padStart(10, '0');
  let sum = 0;
  let multiplier = 2;

  for (let index = randomNumberStr.length - 1; index >= 0; index--) {
    const multiplicationResult =
      parseInt(randomNumberStr.substring(index, index + 1), 10) * multiplier;

    sum += multiplicationResult;

    multiplier++;

    if (multiplier > 9) {
      multiplier = 2;
    }
  }

  let verificationDigit = (sum * 10) % 11;
  if (verificationDigit >= 10) verificationDigit = 0;

  return randomNumberStr.concat(String(verificationDigit));
};
